import _regeneratorRuntime from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _PolygonMaskPlugin_engine;

import "./pathseg";
import { PolygonMask } from "./Options/Classes/PolygonMask";
import { PolygonMaskInstance } from "./PolygonMaskInstance";

var PolygonMaskPlugin = /*#__PURE__*/function () {
  function PolygonMaskPlugin(engine) {
    _classCallCheck(this, PolygonMaskPlugin);

    _PolygonMaskPlugin_engine.set(this, void 0);

    this.id = "polygonMask";

    __classPrivateFieldSet(this, _PolygonMaskPlugin_engine, engine, "f");
  }

  _createClass(PolygonMaskPlugin, [{
    key: "getPlugin",
    value: function getPlugin(container) {
      return new PolygonMaskInstance(container, __classPrivateFieldGet(this, _PolygonMaskPlugin_engine, "f"));
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options, source) {
      if (!this.needsPlugin(source)) {
        return;
      }

      var optionsCast = options;
      var polygonOptions = optionsCast.polygon;

      if ((polygonOptions === null || polygonOptions === void 0 ? void 0 : polygonOptions.load) === undefined) {
        optionsCast.polygon = polygonOptions = new PolygonMask();
      }

      polygonOptions.load(source === null || source === void 0 ? void 0 : source.polygon);
    }
  }, {
    key: "needsPlugin",
    value: function needsPlugin(options) {
      var _a, _b, _c;

      return (_b = (_a = options === null || options === void 0 ? void 0 : options.polygon) === null || _a === void 0 ? void 0 : _a.enable) !== null && _b !== void 0 ? _b : ((_c = options === null || options === void 0 ? void 0 : options.polygon) === null || _c === void 0 ? void 0 : _c.type) !== undefined && options.polygon.type !== "none";
    }
  }]);

  return PolygonMaskPlugin;
}();

_PolygonMaskPlugin_engine = new WeakMap();
export function loadPolygonMaskPlugin(_x) {
  return _loadPolygonMaskPlugin.apply(this, arguments);
}

function _loadPolygonMaskPlugin() {
  _loadPolygonMaskPlugin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engine) {
    var plugin;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            plugin = new PolygonMaskPlugin(engine);
            _context.next = 3;
            return engine.addPlugin(plugin);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadPolygonMaskPlugin.apply(this, arguments);
}

export * from "./Enums/PolygonMaskInlineArrangement";
export * from "./Enums/PolygonMaskMoveType";
export * from "./Enums/PolygonMaskType";
export * from "./Options/Interfaces/IPolygonMaskOptions";